import { memo } from 'react';
import { useCallback, useEffect } from 'react';
import { FC, useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router';

import { APP_ROUTES } from '@navigation/types';
import { useCurrentShowId } from '@redux/selectors/shows';
import { AppDispatch } from '@redux/store';
import { showsSlice } from '@redux/state/showsSlice';
import { ShowStatus } from '@typings/show';
import Modal from '@components/modal';
import { colors } from 'theme/colors';
import { DefaultText } from '@components/text';
import Loader from '@components/loader';
import { useLazyGetShowByIdQuery } from '@redux/queries/show';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.black};
`;

// type Props = {};

const ShowInitialization: FC = () => {
  const currentShowId = useCurrentShowId();
  const [isErrorModalVisible, setIsErrorModalVisible] =
    useState<boolean>(false);
  // const [isPaymentModalVisible, setIsPaymentModalVisible] =
  //   useState<boolean>(false);
  const [isWaitingForPayment] = useState<boolean>(false);
  const location = useLocation();
  const params = useParams<{ id: string }>();
  const id = params.id || (location.state as { id?: string })?.id;
  //   const paymentData = useShowPaymentData(showId);
  //   const { initPaymentSheet, presentPaymentSheet } = useStripe();
  const [getShowById, { data, isFetching, isSuccess, isError }] =
    useLazyGetShowByIdQuery();
  //   const [
  //     payForListen,
  //     { isLoading: isPayForListenLoading, isSuccess: isPayForListenSuccess },
  //   ] = usePayForListenMutation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const goBack = useCallback(() => {
    navigate(APP_ROUTES.HOME, { replace: true });
  }, [navigate]);

  // const onCloseModal = useCallback(() => {
  //   setIsErrorModalVisible(false);
  //   dispatch(
  //     showsSlice.actions.setShowDataById({
  //       id,
  //       status: ShowStatus.Finished,
  //     }),
  //   );
  //   // dispatch(
  //   //   feedState.actions.removeLiveShowFromSuggestedIds({
  //   //     id,
  //   //   }),
  //   // );
  //   // dispatch(
  //   //   feedState.actions.removeLiveShowFromFollowingIds({
  //   //     id: showId,
  //   //   }),
  //   // );
  //   navigate('/');
  // }, [navigate, dispatch, id]);

  const onCloseErrorModal = useCallback(() => {
    setIsErrorModalVisible(false);
    goBack();
  }, [goBack]);

  //   const onYesPress = useCallback(() => {
  //     payForListen({ showId });
  //   }, [showId, payForListen]);

  //   const requestPayment = useCallback(async () => {
  //     const { stripeCustomerId, ephemeralKey, paymentIntent } = paymentData ?? {};
  //     if (!stripeCustomerId || !ephemeralKey || !paymentIntent) {
  //       return;
  //     }

  //     setIsWaitingForPayment(true);

  //     const { error } = await initPaymentSheet({
  //       merchantDisplayName: 'Omili',
  //       customerId: stripeCustomerId,
  //       customerEphemeralKeySecret: ephemeralKey,
  //       paymentIntentClientSecret: paymentIntent,
  //       allowsDelayedPaymentMethods: true,
  //       returnURL: `${process.env.REACT_APP_MAIN_SITE}/stripe-redirect`,
  //     });

  //     if (error) {
  //       console.log('requestPayment ERROR', error);
  //       goBack();
  //       return;
  //     }

  //     const { error: paymentSheetError } = await presentPaymentSheet();

  //     if (paymentSheetError) {
  //       console.log('requestPayment paymentSheetError', paymentSheetError);
  //       goBack();
  //       return;
  //     }
  //   }, [paymentData, initPaymentSheet, presentPaymentSheet, goBack]);

  useEffect(() => {
    if (id) {
      getShowById({ id, _ts: new Date().getTime() }, false);
    }
  }, [getShowById, id]);

  useEffect(() => {
    if (isSuccess && id) {
      if (data === null) {
        setIsErrorModalVisible(true);
        return;
      } else if (data?.status === ShowStatus.Finished && data?.recorded) {
        dispatch(showsSlice.actions.setCurrentRecordedShowId(id));
        navigate(`${APP_ROUTES.SHOW_RECORDED}/${id}`, { replace: true });
      } else if (data?.status === ShowStatus.Scheduled) {
        navigate(`${APP_ROUTES.SHOW_SCHEDULED}/${id}`, { replace: true });
      } else if (data?.status === ShowStatus.Live) {
        if (data?.needToPay) {
          // setIsPaymentModalVisible(true);
          //   Alert.alert(
          //     `You're about to join a Pay to Listen show for ${CURRENCY}${data?.priceForListen}.`,
          //     'Ready to dive in?',
          //     [
          //       {
          //         text: 'Yes',
          //         onPress: onYesPress,
          //       },
          //       {
          //         text: 'No',
          //         style: 'cancel',
          //         onPress: () => {
          //           goBack();
          //         },
          //       },
          //     ],
          //   );
        } else {
          dispatch(showsSlice.actions.setCurrentShowId(id));
        }
      }
    }
  }, [isSuccess, data, goBack, id, dispatch, navigate]);

  useEffect(() => {
    if (isError) {
      setIsErrorModalVisible(true);
    }
  }, [isError]);

  //   useEffect(() => {
  //     if (isPayForListenSuccess && paymentData) {
  //       requestPayment();
  //     }
  //   }, [isPayForListenSuccess, paymentData, requestPayment]);

  //   useEffect(() => {
  //     socket.on(
  //       `paid-show-status-${user?.id}`,
  //       ({ id, status }: { id: string; status: PaidShowStatus }) => {
  //         if (status === PaidShowStatus.Success) {
  //           dispatch(
  //             shows.actions.updateShowDataById({
  //               id,
  //               paymentData: {},
  //             }),
  //           );
  //           dispatch(shows.actions.addShowToPaidShowsIds(id));
  //           dispatch(shows.actions.setCurrentShow(id));
  //         }

  //         if (status === PaidShowStatus.Failed) {
  //           Alert.alert('Payment error!', 'Payment error', [
  //             {
  //               text: 'Got it!',
  //               style: 'cancel',
  //               onPress: () => {
  //                 goBack();
  //               },
  //             },
  //           ]);
  //         }
  //       },
  //     );

  //     setIsWaitingForPayment(false);

  //     return () => {
  //       socket.off(`paid-show-status-${user?.id}`);
  //     };
  //   }, [showId, user?.id, dispatch, goBack]);

  useEffect(() => {
    if (
      currentShowId === id &&
      location.pathname.includes(APP_ROUTES.SHOWS_INITIALIZATION)
    ) {
      navigate(`${APP_ROUTES.SHOW_LIVE}/${id}`, { replace: true });
    }
  }, [currentShowId, id, location.pathname, navigate]);

  if (isFetching || isWaitingForPayment) {
    return (
      <Container>
        <Loader size='large' color={colors.grey[200]} />

        {isWaitingForPayment && (
          <DefaultText>{'Waiting for payment...'}</DefaultText>
        )}
      </Container>
    );
  }

  if (isErrorModalVisible) {
    return (
      <Modal
        isShown={isErrorModalVisible}
        isCloseable
        onClose={onCloseErrorModal}
        title={'Show does not exist!'}
      />
    );
  }

  return <Container />;
};

export default memo(ShowInitialization);
